//@flow
import React from 'react';
import Link from './../../../components/Link';
import ItemQtyWrapper from '../../ItemQty/components/ItemQtyWrapper.react';
import CartItemQty from './CartItemQty.react';
import QuoteActions from '../../Actions/quote';
import NumberUtils from '../../Utils/number';
import MsrpProductPrices from '../../ProductDetails/components/MsrpProductPrices.react';

import type ProductModel from '../../Stores/Products/productModel';
import type ProductsCollection from '../../Stores/Products/productsCollection';
import type QuoteItemModel from '../../Stores/Quote/quoteItemModel';
import type QuoteModel from '../../Stores/Quote/quoteModel';
import type MembershipPlanModel from '../../Stores/Membership/membershipPlanModel';

type Props = {
  className:string,
  inCart:boolean,
  quoteItem:QuoteItemModel,
  products:ProductsCollection,
  quote:QuoteModel,
  lessTextMsrp?:boolean,
  strikeUnselectedPrice?:boolean,
  preSale:?boolean,
  membershipPlan:MembershipPlanModel,
};

export default class QuoteItem extends React.Component<Props> {
  _getImageUrl(product:ProductModel) {
    return product.getSmallSquareImageUrl(96,96);
  }

  _getName(product:ProductModel) {
    return product.getName();
  }

  _isFree(product:ProductModel) {
    return /^free/i.test(product.getName());
  }

  _renderImage(product:ProductModel) {
    const img = <img src={this._getImageUrl(product)} alt={this._getName(product)} />;

    if (!this.props.inCart) return img;

    return (
      <Link className="image-holder" to={product.getUrl()} external={true}>
        {img}
      </Link>
    );
  }

  _renderName(product:ProductModel) {
    if (!this.props.inCart) {
      return <div className="item-name">{this._getName(product)}</div>;
    }

    return <Link to={product.getUrl()} className="item-name" external={true}>{this._getName(product)}</Link>;
  }

  _removeProduct = () => {
    QuoteActions.deleteQuoteItem(this.props.quoteItem);
  }

  _renderSize(product:ProductModel) {
    const size = NumberUtils.getWeightOz(product.getWeight());
    if (size) {
      return (<span className="item-size">{size} oz</span>);
    }
  }

  _getPriceComponent(product:ProductModel) {
    return (
      <div className="item-price-qty">
        <MsrpProductPrices
          product={product}
          quote={this.props.quote}
          lessText={this.props.lessTextMsrp}
          strikeUnselectedPrice={this.props.strikeUnselectedPrice}
          hideMemInfo={false}
          membershipPlan={this.props.membershipPlan}
        />
      </div>
    );
  }

  _renderPreSaleNotice() {
    if (!this.props.preSale) return null;

    return (
      <div className="presale-notice">
        This product is launching soon and will ship when it’s available.
      </div>
    );
  }


  render() {
    const sku = this.props.quoteItem.getSku();
    const product = this.props.products.getProductBySku(sku);

    if (!product) return null;

    const size = this._renderSize(product);
    const detailsClass = this._isFree(product) ? 'item-details-select item-free' : 'item-details-select';

    return(
      <div className={this.props.className}>
        {this._renderImage(product)}
        <div className={detailsClass}>
          <div className="item-details">
            {this._renderName(product)}
            <div className="size hide-cart-preview">{this._renderSize(product)}</div>
            {this._getPriceComponent(product)}
            {this._renderPreSaleNotice()}
            <div className="show-cart-preview">
              {size && <span className="size">{size}</span>}
              <span onClick={this._removeProduct} className="remove">Remove </span>
            </div>
          </div>
          <ItemQtyWrapper
            maxQty={20}
            className="detail-select"
            displayComponentClass={CartItemQty}
            sku={this.props.quoteItem.getSku()}
            qty={this.props.quoteItem.getQty()}
            quoteId={this.props.quote.getId()}
          />
        </div>
      </div>
    );
  }
}
